/**
* Footer component
* @returns <Footer />
*/
import { Link } from "react-router-dom"

const Footer = () => {
    const data = {
        socialLinks: [
            {
                id: 1,
                image: `${window._env_.STATIC_HOST}/static/website/images/social-media/facebook.svg`,
                link: "https://www.facebook.com/lexuschile"
            },
            {
                id: 2,
                image: `${window._env_.STATIC_HOST}/static/website/images/social-media/twitter.svg`,
                link: "https://www.twitter.com/lexus_chile"
            },
            {
                id: 3,
                image: `${window._env_.STATIC_HOST}/static/website/images/social-media/youtube.svg`,
                link: "https://www.youtube.com/users/lexuschile"
            },
            {
                id: 4,
                image: `${window._env_.STATIC_HOST}/static/website/images/social-media/instagram.svg`,
                link: "https://www.instagram.com/lexus_chile"
            },
        ],

        termsLinks: [
            {
                id: 4,
                icon: true,
                isAnchor: true,
                link: "/es",
                label: "Lexus",
            },
            {
                id: 5,
                icon: false,
                isAnchor: false,
                link: "/termino-y-condiciones-tienda",
                label: "Términos y condiciones"
            },
            {
                id: 6,
                icon: false,
                isAnchor: false,
                link: "/politicas-de-privacidad",
                label: "Políticas de privacidad"
            }
        ]
    }

    return (
        <footer className="footer">
            <div className="wrapper">
                <div className="footer-grid">
                    <aside className="footer-grid__contact_store">
                        <span>
                            <h4><strong>¿NECESITAS AYUDA?</strong></h4>
                            <p>Escríbenos a través de contacto@lexus.cl y nos pondremos en contacto rápidamente.</p>
                        </span>

                        <div className="footer-grid__social-buttons">
                            <p>Síguenos en nuestras redes</p>
                            <span>
                                {/* Social Links list */}
                                {data.socialLinks.map((socialLink) => {
                                    return (
                                        <a href={socialLink.link} className="social-media-btn" target="_blank" key={socialLink.id}><img src={socialLink.image} alt="" /></a>
                                    )
                                })}
                            </span>
                        </div>
                    </aside>

                    <aside className="footer-grid__terms_store">
                        <p className="copyright --text-m">Copyright © Lexus 2023. Todos los derechos reservados.</p>
                        <ul className="links">
                            {data.termsLinks.map((termsLink) => {
                                if (termsLink.isAnchor) {
                                    return (
                                        <li key={termsLink.id}>
                                            <a href={termsLink.link} target="_blank">
                                                {termsLink.label}
                                                {termsLink.icon && (<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.08333 6.91659L6.91666 1.08325M6.91666 1.08325H1.08333M6.91666 1.08325V6.91659" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>)}
                                            </a>
                                        </li>
                                    )
                                } else {
                                    return (
                                        <li key={termsLink.id}>
                                            {/* <Link to={termsLink.link}> */}
                                            <a href={termsLink.link} target="_blank">
                                                {termsLink.label}
                                                {termsLink.icon && (<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.08333 6.91659L6.91666 1.08325M6.91666 1.08325H1.08333M6.91666 1.08325V6.91659" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>)}
                                            </a>
                                            {/* </Link> */}
                                        </li>
                                    )
                                }
                            })}
                        </ul>
                    </aside>
                </div>
            </div>
        </footer>
    )
}

export default Footer